export const FINANCED_VALUE = 'Valor financiado';

export const TOTAL_DEBT_BALANCE = 'Saldo total de la deuda:';

export const TOTAL_VALUE_IN_ARREARS = 'Valor total en mora:';

export const VALUE_TO_PAY = 'Valor a pagar:';